
/* eslint-disable */

import './style.js';

/** this is a stripped-down version, the full version is in /operator/dev/src/libs/common/custom-scroll */
class CustomScroll {
    constructor(scroller, scrollTo = 0, isCalculateScrollerWidth = true, isScrollBarInParent = true) {
        this.state = {
            actualScrollTop: 0,
            isMove: false,
            isShow: true,
            startMouPos: 0,
            isRTL: this.handleIsRTL(),
        };

        this.params = {
            parent: scroller.parentElement,
            scrollWrapper: isScrollBarInParent ? scroller.parentElement : scroller.children[0],
            scroller,
            scrollTo,
            isCalculateScrollerWidth,
            isScrollBarInParent,

            scrollBarContainer: undefined,
            scrollBar: undefined,
        };

        this.recalculate = this.recalculate.bind(this);
        this.onceRecalculate = this.onceRecalculate.bind(this);
        this.unmount = this.unmount.bind(this);

        this.handleInitializationOnFirstStart();
    }

    /** public */
        recalculate() {
            this.onceRecalculate();
            setTimeout(this.onceRecalculate, 1);
        }

        onceRecalculate() {
            if (this.handleIsShow()) {
                this.handleMoveScrollBarToCurrentPosition(this.params.scroller.scrollTop);
                this.handleCalculateScrollBarHeight();
            }
            this.handleCalculateScrollerWidth();
        }

        changeScrollPositionByBarPosition() {
            const scrollBar = parseInt(this.params.scrollBar.style.top, 10);
            const newScrollTop = scrollBar / this.handleGetRatio();
            this.params.scroller.scrollTop = newScrollTop;
            this.onScroll();
        }

        unmount() {
            window.removeEventListener('resize', this.recalculate);
        }

    /** First Start */
        handleInitializationOnFirstStart() {
            // this.handleCalculateScrollerWidth();
            setTimeout(this.handleCalculateScrollerWidth.bind(this), 1);
            this.handleCreateScrollBar();
            this.handleAttachClasses();
            this.handleCalculateScrollBarHeight();
            this.handleSetStartScrollPosition();
            
            if (this.handleIsShow()) {
                this.handleMoveScrollBarToCurrentPosition(this.params.scroller.scrollTop);
            }
            this.fireOnListeners();
        }

        handleCreateScrollBar() {
            this.params.scrollBarContainer = document.createElement('div');
            this.params.scrollBar = document.createElement('div');

            this.params.scrollBarContainer.appendChild(this.params.scrollBar);
            this.params.scrollWrapper.appendChild(this.params.scrollBarContainer);
        }

        handleAttachClasses() {
            this.params.scrollBarContainer.className = 'scrollBar-container';
            this.params.scrollBar.className = 'scrollBar';
            this.params.scrollWrapper.classList.add('custom-scroll__wrapper');
            if (this.params.isCalculateScrollerWidth) {
                this.params.parent.classList.add('hide-scroll');
            }
            this.params.scroller.classList.add('custom-scroll__scroller');
        }

        handleSetStartScrollPosition() {
            if (this.params.scrollTo) {
                this.params.scroller.scrollTop = this.params.scrollTo;
                this.params.scrollBar.style.top = this.params.scrollTo / this.handleGetRatio() + 'px';
            }
        }

        /*
        * launches all the necessary listeners
        */
        fireOnListeners() {
            this.params.scroller.addEventListener('scroll', this.onScroll.bind(this));
            
            this.params.scrollBar.addEventListener('mousedown', this.onStartMove.bind(this));
            document.addEventListener('mousemove', function(e) {
                if (this.state.isMove) {
                    this.onMove(Math.ceil(e.pageY - window.pageYOffset));
                }
            }.bind(this));
            document.addEventListener('mouseup', this.onFinishMove.bind(this));

            window.addEventListener('resize', this.recalculate);
        }

    /** Scroll */
        onScroll(e) {
            if (this.handleIsShow()) {
                this.handleCalculateScrollBarHeight();
                this.state.actualScrollTop = this.params.scroller.scrollTop;
                this.handleMoveScrollBarToCurrentPosition(this.state.actualScrollTop);
            }
        }

        onStartMove(e) {
            if (this.state.isShow) {
                e = e.x ? e : e.changedTouches[0];
                this.state.startMouPos = Math.ceil(e.pageY - window.pageYOffset);
                this.state.isMove = true;
                this.handleCalculateScrollBarHeight();
            }
        }

        onMove(mousePos) {
            let scrollBarTop = parseInt(this.params.scrollBar.style.top, 10);
            if (!this.params.isScrollBarInParent) scrollBarTop -= this.params.scroller.scrollTop;
            const movement = mousePos - this.state.startMouPos;
            const newPosition = scrollBarTop + movement;

            if (newPosition < 0) {
                this.state.startMouPos -= scrollBarTop;
                this.params.scrollBar.style.top = '0px';
                this.params.scroller.scrollTop = 0;
            } else {
                let maxPosition = this.params.scroller.offsetHeight - this.params.scrollBar.offsetHeight;

                if (newPosition > maxPosition) {
                    this.state.startMouPos += maxPosition - scrollBarTop;
                    this.params.scroller.scrollTop =
                                this.params.scroller.scrollHeight - this.params.scroller.offsetHeight;
                    this.handleScrollBarSetNewPosition(maxPosition);
                
                } else {
                    this.state.startMouPos = mousePos;
                    this.params.scroller.scrollTop = newPosition / this.handleGetRatio();
                    this.handleScrollBarSetNewPosition(newPosition);
                }
            }
        }

        onFinishMove(e) {
            this.state.isMove = false;
        }

    /** DEVKIT */
        handleCalculateScrollerWidth(){
            if (!this.params.isCalculateScrollerWidth) return;

            if (this.params.scroller.offsetWidth < this.params.scroller.scrollWidth) {
                this.params.scroller.style.width = 'auto';
                return;
            }

            let browserScrollWidth = this.params.scroller.offsetWidth - this.params.scroller.scrollWidth;
            if (browserScrollWidth > 0 && this.params.scroller.tagName === 'TEXTAREA') {
                browserScrollWidth += 2;
            }

            this.params.scroller.style.width = this.params.parent.offsetWidth + browserScrollWidth + 'px';
        }

        handleScrollBarSetNewPosition(newPosition) {
            if (!this.params.isScrollBarInParent) newPosition += this.params.scroller.scrollTop;
            this.params.scrollBar.style.top = newPosition + 'px';
        }

        handleCalculateScrollBarHeight() {
            const newHeight = Math.floor(this.params.scroller.offsetHeight * this.handleGetRatio());
            this.params.scrollBar.style.height = newHeight + 'px';
        }

        handleIsShow() {
            if (this.params.scroller.offsetHeight >= this.params.scroller.scrollHeight) {
                if (this.state.isShow) {
                    this.state.isShow = false;
                    this.params.scrollBarContainer.classList.add('hidden');
                    return false;
                }
            } else {
                if (!this.state.isShow) {
                    this.state.isShow = true;
                    this.params.scrollBarContainer.classList.remove('hidden');
                }
                return true;
            }
        }

        handleMoveScrollBarToCurrentPosition(scrollTop) {
            const newPosition = this.params.isScrollBarInParent
                ? scrollTop * this.handleGetRatio()
                : scrollTop * this.handleGetRatio() + scrollTop;

            this.params.scrollBar.style.top = Math.floor(newPosition) + 'px';
        }

        handleGetRatio() {
            return this.params.scroller.offsetHeight / this.params.scroller.scrollHeight;
        }

        handleIsRTL() {
            return !!~document.getElementsByTagName('body')[0].dir.indexOf('rtl');
        }
}
export default CustomScroll;
